import request from '@/config/axios'

// ===================== 路线规划管理 =====================

/** 获取路线分页列表 */
export const getRoutePlanningPage = (params: any) => {
  return request.get({ url: '/scenic/route-planning/page', params })
}

/** 获取路线详情 */
export const getRoutePlanning = (id: number) => {
  return request.get({ url: '/scenic/route-planning/get', params: { id } })
}

/** 创建路线 */
export const createRoutePlanning = (data: any) => {
  return request.post({ url: '/scenic/route-planning/create', data })
}

/** 更新路线 */
export const updateRoutePlanning = (data: any) => {
  return request.put({ url: '/scenic/route-planning/update', data })
}

/** 删除路线 */
export const deleteRoutePlanning = (id: number) => {
  return request.delete({ url: '/scenic/route-planning/delete', params: { id } })
}

/** 发布路线 */
export const publishRoutePlanning = (id: number) => {
  return request.post({ url: '/scenic/route-planning/publish', params: { id } })
}

/** 下线路线 */
export const offlineRoutePlanning = (id: number) => {
  return request.post({ url: '/scenic/route-planning/offline', params: { id } })
}

/** 获取路线统计数据 */
export const getRoutePlanningStats = () => {
  return request.get({ url: '/scenic/route-planning/stats' })
}

// ===================== POI 管理 =====================

/** 获取POI分页列表 */
export const getPoiPage = (params: any) => {
  return request.get({ url: '/scenic/route-planning/poi/page', params })
}

/** 获取POI详情 */
export const getPoi = (id: number) => {
  return request.get({ url: '/scenic/route-planning/poi/get', params: { id } })
}

/** 创建POI */
export const createPoi = (data: any) => {
  return request.post({ url: '/scenic/route-planning/poi/create', data })
}

/** 更新POI */
export const updatePoi = (data: any) => {
  return request.put({ url: '/scenic/route-planning/poi/update', data })
}

/** 删除POI */
export const deletePoi = (id: number) => {
  return request.delete({ url: '/scenic/route-planning/poi/delete', params: { id } })
}

/** 获取POI分类统计 */
export const getPoiCategoryStats = () => {
  return request.get({ url: '/scenic/route-planning/poi/category-stats' })
}

/** 导入POI模板下载 */
export const getPoiImportTemplate = () => {
  return request.get(
    { url: '/scenic/route-planning/poi/import-template', responseType: 'blob' },
    { isReturnNativeResponse: false }
  )
}

/** 导入POI */
export const importPoi = (data: FormData) => {
  return request.post({
    url: '/scenic/route-planning/poi/import',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
